import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const ModelProvider = lazy(()=> import(/* webpackChunkName: "Model Provider" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/model-provider" component={ModelProvider} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/ModelProvider/routes.js